import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const adminCompany = createApi({
  reducerPath: "adminCompany",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["companies", "company"],
  endpoints: (builder) => ({
    getCompanies: builder.query({
      query: ({ startRow, endRow, query = "", filter = { service: "" } }) => ({
        url: `/admin/UserCompany/list?query=${query.toLowerCase()}&serviceId=${
          filter.service
        }`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { startRow, endRow },
      }),
      providesTags: ["companies"],
    }),
    getCompanyId: builder.query({
      query: (id) => ({
        url: "/admin/UserCompany/" + id,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["company"],
    }),
    getAtecoCode: builder.query({
      query: () => ({
        url: "data/guest/atecoCodes",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    createCompany: builder.mutation({
      query: (body) => ({
        url: `admin/UserCompany`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["companies"],
    }),
    deleteCompany: builder.mutation({
      query: (companyId) => ({
        url: "/admin/UserCompany/" + companyId,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { companyId },
      }),
      invalidatesTags: ["companies"],
    }),
    editCompany: builder.mutation({
      query: (company) => ({
        url: "/admin/UserCompany/" + company.id,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: company,
      }),
      invalidatesTags: ["companies", "company"],
    }),
  }),
});

export const {
  useGetCompaniesQuery,
  useGetCompanyIdQuery,
  useGetAtecoCodeQuery,
  useCreateCompanyMutation,
  useDeleteCompanyMutation,
  useEditCompanyMutation,
} = adminCompany;
